/**
 * Apple Pay domain validation requires each processor to be verified on specific domains:
 *   - Fortis: verified on "webclip.*" domains (e.g. webclip.getunion.com)
 *   - Magensa Unigate: verified on "clip.*" domains (e.g. clip.getunion.com)
 *
 * If a venue's payment_processor doesn't match the current domain, Apple Pay
 * will fail domain validation. This function detects the mismatch and returns
 * a redirect URL to the correct domain, preserving the full path and query params.
 *
 * Returns null when no redirect is needed (domain matches, or we're on a
 * non-deployed domain like localhost/ngrok where the check doesn't apply).
 */
export function getProcessorDomainRedirect(processor: string | undefined): string | null {
  if (typeof window === 'undefined' || !processor) return null

  const { hostname } = window.location
  const isWebclipDomain = hostname.startsWith('webclip.')
  const isClipDomain = hostname.startsWith('clip.')

  if (!isWebclipDomain && !isClipDomain) return null

  if (processor === 'fortis' && isClipDomain) {
    const newHostname = 'webclip.' + hostname.slice('clip.'.length)
    return window.location.href.replace(hostname, newHostname)
  }

  if (processor === 'magensa_unigate' && isWebclipDomain) {
    const newHostname = 'clip.' + hostname.slice('webclip.'.length)
    return window.location.href.replace(hostname, newHostname)
  }

  return null
}
